import type { ToothMassCentroidMm } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type {
  FullHeadMprSliceGroupView,
  FullHeadMprSliceTileView,
  ToothExtentsProfiles,
} from '../config';

import { makeDefaultToothSlicePlanes } from './makeDefaultToothSlicePlanes';

export const makeDefaultFullHeadMprSliceSelection = ({
  groups,
  massCentroidMm,
  profiles = null,
}: {
  groups: FullHeadMprSliceGroupView[];
  massCentroidMm: ToothMassCentroidMm | null;
  profiles?: ToothExtentsProfiles | null;
}): FullHeadMprSliceTileView[] =>
  makeDefaultToothSlicePlanes({
    massCentroidMm,
    profiles,
    series: groups.map((group) => ({
      name: group.seriesName,
      offsetsMm: group.tiles.map((tile) => tile.offsetMm),
    })),
  }).flatMap((plane) => {
    const tile = groups
      .find((group) => group.seriesName === plane.seriesName)
      ?.tiles.find((candidate) => candidate.offsetMm === plane.offsetMm);

    return tile ? [tile] : [];
  });
